/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface MonitorCreationSpecForEligibleDeployments { 
    service_type: VcdsServiceTypeEnum;
    cloud_provider: CloudProviderEnum;
    /**
     * If executed in dry run mode, eligible deployments for which monitors are required to be created are listed.
     */
    dry_run?: boolean;
}
export namespace MonitorCreationSpecForEligibleDeployments {
}


